import * as React from "react";
const SvgFiRrArrowsAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-arrows-alt_svg__a)">
      <path
        fill="#062147"
        d="m23.731 11.356-3.343-3.3A.815.815 0 0 0 19 8.638V11h-6V5h2.363a.816.816 0 0 0 .58-1.389L12.644.271a.9.9 0 0 0-1.288 0l-3.3 3.341A.816.816 0 0 0 8.637 5H11v6H5V8.638a.816.816 0 0 0-1.388-.58l-3.343 3.3a.906.906 0 0 0 0 1.288l3.343 3.3A.817.817 0 0 0 5 15.363V13h6v6H8.637a.816.816 0 0 0-.58 1.39l3.3 3.341a.9.9 0 0 0 1.288 0l3.3-3.342A.816.816 0 0 0 15.363 19H13v-6h6v2.363a.816.816 0 0 0 1.388.581l3.343-3.3a.904.904 0 0 0 0-1.288"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-arrows-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrArrowsAlt;
